interface BankBuildingIconProps {
  className?: string;
}

function BankBuildingIcon({ className }: BankBuildingIconProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      focusable="false"
      viewBox="0 0 130 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M124.366 53.43C129.196 53.43 131.211 47.225 127.286 44.365L67.6163 0.960001C66.8063 0.360001 65.7863 0 64.6763 0C63.5663 0 62.5513 0.36 61.7263 0.97L61.7413 0.960001L2.07132 44.365C-1.84868 47.21 0.166317 53.43 5.01132 53.43H14.6813V111.87H3.43132C2.74132 111.87 2.18132 112.435 2.18132 113.12V121.245C2.18132 121.93 2.74132 122.495 3.43132 122.495H125.931C126.616 122.495 127.181 121.93 127.181 121.245V113.12C127.181 112.435 126.616 111.87 125.931 111.87H114.681V53.43H124.366ZM64.6813 11.975L107.041 42.785H22.3213L64.6813 11.975ZM25.9313 53.43H44.2113V111.87H25.9313V53.43ZM55.4613 53.43H73.7413V111.87H55.4613V53.43ZM103.431 111.865H84.9913V53.425H103.431V111.865Z"
        fill="currentColor"
      />
    </svg>
  );
}

export { BankBuildingIcon };
